import { render, staticRenderFns } from "./menucfg.vue?vue&type=template&id=4d31a73f"
import script from "./menucfg.vue?vue&type=script&lang=js"
export * from "./menucfg.vue?vue&type=script&lang=js"
import style0 from "./menucfg.vue?vue&type=style&index=0&id=4d31a73f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports